module.exports = __webpack_public_path__ + "static/award1-f24e85c0ccf71554edea55fc410eba7d.png";